export default {"src":"/_next/static/media/acces-cheminement.574116cd.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};